import Cookies from 'utils/Cookies'; // eslint-disable-line
import Observer from 'utils/Observer';
import Toggle from 'toggle/Toggle';
import Trigger from 'toggle/Trigger';

/**
 * * Class CookieBar that handles base functionality for hide show cookie-bar.
 * @class
 */
class CookieBar {

    /**
     * Make a new CookieBar.
     * @constructs
     * @param {HTMLElement} element - The HTMLElement this module is constructed upon
     * @param {Object} options - ConditionerJS's merged options
     */
    constructor(element, options) {

        this._element = element;
        this._options = options;
        this._onConsentBind = this._onConsent.bind(this);

        this._initialize();

    }

    /**
     * Initialize
     * @private
     */
    _initialize() {
        let consent = Cookies.hasItem(this._options.cookieName);
        if (consent) {
            this._element.parentNode.removeChild(this._element);

        } else {
            this._element.style.display = 'block';

            let triggerElement;
            // Setup toggle & trigger, so we can animate the consent bar away
            triggerElement = document.getElementById(this._options.consentButton);
            this._toggle = new Toggle(this._element, {});
            this._trigger = new Trigger(triggerElement, { targets: this._element.id });
            this._element.style.marginTop = '0';

            this._bindEvents();
        }
    }

    /**
     * Bind events
     * @method _bindEvents
     * @private
     */
    _bindEvents() {
        Observer.subscribe(this._toggle, 'active', this._onConsentBind);
    }

    /**
     * Set cookie on user consent and reload the page after the animation
     * @method _initialize
     * @private
     */
    _onConsent() {
        // The user consented
        Cookies.setItem(this._options.cookieName, this._getUniqueId(), Infinity, '/', this._getDomain(), false);
        this._element.parentNode.removeChild(this._element);
    }

    /**
     * @returns {string} - string text
     * @private
     */
    _getDomain() {

        let domain = window.location.hostname;
        if (domain.indexOf('.') !== -1) {
            domain = domain.split('.');

            return `. ${domain[domain.length - 2]} . ${domain[domain.length - 1]}`;
        }

        return domain;
    }

    /**
     * @returns {string} - string
     * @private
     */
    _getUniqueId() {
        let agent = this._toHashCode(navigator.userAgent);
        let now = new Date();
        let timestamp = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());

        return `${timestamp} - ${agent.toString()}`;
    }

    /**
     * @param {string} string -  string
     * @returns {number} - int
     * @private
     */
    _toHashCode(string) {
        let ha = 0;
        let i;
        let ch;
        let l = string.length;

        if (l === 0) { return ha; }
        for (i = 0; i < l; i++) {
            ch = string.charCodeAt(i);
            ha = (ha << 5) - ha + ch;
            // Convert to 32bit integer
            ha = ha & ha;
        }

        return ha;
    }
}

export default CookieBar;
